import { render, staticRenderFns } from "./external-detailed.vue?vue&type=template&id=6d654bd6&scoped=true"
import script from "./external-detailed.vue?vue&type=script&lang=js"
export * from "./external-detailed.vue?vue&type=script&lang=js"
import style0 from "./external-detailed.vue?vue&type=style&index=0&id=6d654bd6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d654bd6",
  null
  
)

export default component.exports